import { ApolloProvider } from '@apollo/client/react';

import getApolloClient from './apollo.client';

interface Props {
  apiHost: string;
  children: React.ReactNode;
}

export default function ApolloProviderWithClient({ apiHost, children }: Props) {
  const client = getApolloClient(apiHost);
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
